import { render, staticRenderFns } from "./DlgEventNew.vue?vue&type=template&id=7080b94a&scoped=true"
import script from "./DlgEventNew.vue?vue&type=script&lang=js"
export * from "./DlgEventNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7080b94a",
  null
  
)

export default component.exports